(() => {
  const loadRecommendations = (root) => {
    if (!root || root.dataset.caRecommendationsLoaded === 'true') return;

    root.dataset.caRecommendationsLoaded = 'true';
    const list = root.querySelector('[data-ca-recommendations-list]');
    const productId = root.dataset.productId;
    const limit = Number(root.dataset.limit || 6);
    const intent = root.dataset.intent || 'related';
    const endpoint = root.dataset.endpoint;

    if (!list || !productId || !endpoint) {
      root.hidden = true;
      return;
    }

    const query = new URLSearchParams({
      product_id: productId,
      limit: String(limit),
      intent
    });

    fetch(`${endpoint}?${query.toString()}`, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);
        return response.json();
      })
      .then((payload) => {
        const products = Array.isArray(payload.products) ? payload.products : [];
        const items = products
          .filter((product) => String(product.id) !== String(productId))
          .slice(0, limit);

        if (!items.length) {
          root.hidden = true;
          return;
        }

        const fragment = document.createDocumentFragment();
        items.forEach((product) => {
          const handle = product.handle;
          const image = product.featured_image || product.images?.[0];
          if (!handle || !image) return;

          const link = document.createElement('a');
          link.className = 'ca-product__recommendation';
          link.href = product.url || `/products/${encodeURIComponent(handle)}`;
          link.title = product.title || '';
          link.setAttribute('aria-label', product.title || 'Recommended product');

          const imageElement = document.createElement('img');
          imageElement.src = image;
          imageElement.alt = product.title || '';
          imageElement.loading = 'lazy';
          imageElement.width = 48;
          imageElement.height = 48;
          link.appendChild(imageElement);
          fragment.appendChild(link);
        });

        if (!fragment.childNodes.length) {
          root.hidden = true;
          return;
        }

        list.replaceChildren(fragment);
      })
      .catch((error) => {
        root.hidden = true;
        console.warn('Product recommendations could not be loaded.', error);
      });
  };

  const init = () => {
    document.querySelectorAll('[data-ca-recommendations]').forEach((root) => {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, instance) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          instance.disconnect();
          loadRecommendations(root);
        }, { rootMargin: '200px' });
        observer.observe(root);
      } else {
        loadRecommendations(root);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
